/* import __COLOCATED_TEMPLATE__ from './image-title-text.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();